import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import { Link } from 'react-router-dom';
import Masthead, { MastheadTitle, MastheadMenuButton} from '@amzn/meridian/masthead';
import Tag from '@amzn/meridian/tag';
import Text from '@amzn/meridian/text';
import Icon from '@amzn/meridian/icon';
import printTokens from '@amzn/meridian-tokens/base/icon/print';
import updateTokens from '@amzn/meridian-tokens/base/icon/update';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import * as AppRoutes from 'src/routing/constants/routes';
import {Icons} from 'src/constants/general-media';

import './TopNav.scss';

interface TopNavStateProps {
    accessibleTools: string[];
    warehouseId: string;
    associate: string;
}

interface TopNavDispatchProps {
    updateOpenSideMenu: (openSideMenu: boolean) => void;
}

type Props = TopNavStateProps & TopNavDispatchProps;

class TopNav extends React.Component<Props> {
    private PRINT = "Print";
    private RECEIVE = "Receive";

    private shouldToolBeVisible = (toolName: string): boolean => {
        if(this.props.accessibleTools.includes(toolName)) {
            return true;
        }
        return false;
    }

    public render() {
        return (
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <div data-testid="top-nav">
                        <Masthead size="small">
                            <MastheadMenuButton onClick={() => this.props.updateOpenSideMenu(true)}/>
                            {/* In scanner screen, there's no space in TopNav for RIV logo */}
                            {!props.isScanner &&
                                <MastheadTitle>
                                    <img
                                        src={Icons.RIV_ICON_SMALL}
                                        alt="RIV logo"
                                    />
                                </MastheadTitle>
                            }
                            <Tag>
                                {this.props.warehouseId}
                            </Tag>
                            <img
                                className="user-image-icon"
                                src={'https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=' + this.props.associate}
                                alt={this.props.associate}
                            />
                            {!this.shouldToolBeVisible(this.PRINT) ? null :
                                <Link to={AppRoutes.PRINT_PAGE_ROUTE}>
                                    <div className="top-nav-buttons">
                                        <Text className="top-nav-buttons-text">{AppStrings.TOP_NAV_BUTTON_PRINT}</Text>
                                        <Icon tokens={printTokens} color="primary"/>
                                    </div>
                                </Link>
                            }
                            {!this.shouldToolBeVisible(this.RECEIVE) ? null :
                                <Link to={AppRoutes.RECEIVE_PAGE_ROUTE}>
                                    <div className="top-nav-buttons">
                                        <Text className="top-nav-buttons-text">{AppStrings.RECEIVE}</Text>
                                        <Icon tokens={updateTokens} color="primary"/>
                                    </div>
                                </Link>
                            }
                        </Masthead>
                    </div>
                )}
            </Responsive>
        )
    }
}

export default TopNav;